import styles from './Toggle.module.css'

/**
 * Toggle — a labeled on/off switch used across Administration (security
 * rights, sensitivity settings). Pure controlled component: the caller owns
 * the checked state and persistence.
 *
 * Props:
 *   checked  {boolean}
 *   onChange {function} — called with the next boolean value
 *   label    {string}   — optional bold label above the switch
 *   description {string} — optional muted line under the label
 *   disabled {boolean}
 *   tone     {'blue'|'green'} — switch-on color; defaults to 'blue'
 */
export default function Toggle({ checked, onChange, label, description, disabled = false, tone = 'blue' }) {
  return (
    <div className={styles.row}>
      {(label || description) && (
        <div className={styles.copy}>
          {label && <span className={styles.label}>{label}</span>}
          {description && <span className={styles.description}>{description}</span>}
        </div>
      )}
      <div className={styles.control}>
        <span className={`${styles.state} ${checked ? styles[`on-${tone}`] : ''}`}>
          {checked ? 'ENABLED' : 'DISABLED'}
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          aria-label={label || undefined}
          disabled={disabled}
          className={`${styles.switch} ${checked ? styles.checked : ''} ${checked ? styles[tone] : ''}`}
          onClick={() => !disabled && onChange(!checked)}
        >
          <span className={styles.thumb} />
        </button>
      </div>
    </div>
  )
}
